import Vue from "vue";

Vue.filter("thousandSeparator", (value) =>
  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
);
